export default "__VITE_ASSET__49ba55ed__"